<template>
  <div class="index">
    <div style="margin-bottom: 10px">
      <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
        <el-breadcrumb-item >首页</el-breadcrumb-item>
        <el-breadcrumb-item>代理商设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="基本设置" name="first">
        <el-row>
          <el-col :span="24">代理商等级别名设置</el-col>
        </el-row>
        <el-form ref="ruleForm" :rules="rules" :model="form" style="margin-top: 10px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div></div>
            </el-col>
            <el-col :span="10">
              <el-form-item label="一级代理" prop="level1_name">
                <el-input v-model="form.level1_name"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6"></el-col>
            <el-col :span="10">
              <el-form-item label="二级代理" prop="level2_name">
                <el-input v-model="form.level2_name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6"></el-col>
            <el-col :span="10">
              <el-form-item label="三级代理" prop="level3_name">
                <el-input v-model="form.level3_name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">代理商等级折扣</el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="6">
              <div></div>
            </el-col>
            <el-col :span="10">
              <el-form-item label="一级代理(折)" prop="level1_discount">
                <el-input v-model="form.level1_discount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div></div>
            </el-col>
            <el-col :span="10">
              <el-form-item label="二级代理(折)" prop="level2_discount">
                <el-input v-model="form.level2_discount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div></div>
            </el-col>
            <el-col :span="10">
              <el-form-item label="三级代理(折)" prop="level3_discount">
                <el-input v-model="form.level3_discount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">代理商其他设置</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="允许代理商修改实际库存">
                <el-switch v-model="form.inventory"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="代理商最低提现金额" prop="amount">
                <el-input v-model="form.amount"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="允许代理商账户欠款">
                <el-switch v-model="form.allow_balance_due"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="代理商账户欠款金额" prop="balance_due">
                <el-input v-model="form.balance_due"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="允许代理商确认收货">
                <el-switch v-model="form.confirm" v-value="form.confirm"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">立即编辑</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
<!--      <el-tab-pane label="名片设置" name="second">配置管理</el-tab-pane>-->
<!--      <el-tab-pane label="代商后台" name="third">角色管理</el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      form: {},
      rules: {
        level1_name: [
          {
            required: true,
            message: "请输入一级代理名称",
            trigger: "blur",
          },
        ],
        level2_name: [
          {
            required: true,
            message: "请输入二级代理名称",
            trigger: "blur",
          },
        ],
        level3_name: [
          {
            required: true,
            message: "请输入三级代理名称",
            trigger: "blur",
          },
        ],
        level1_discount: [
          {
            required: true,
            message: "请输入一级折扣",
            trigger: "blur",
          },
        ],
        level2_discount: [
          {
            required: true,
            message: "请输入二级折扣",
            trigger: "blur",
          },
        ],
        level3_discount: [
          {
            required: true,
            message: "请输入三级折扣",
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入最低提现金额",
            trigger: "blur",
          },
        ],
        balance_due: [
          {
            required: true,
            message: "请输入欠款金额",
            trigger: "blur",
          },
        ],
      },
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    ...mapActions({
      agentIndexAction: "agentIndexAction",
    }),

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.confirm) {
            this.form.confirm = 1;
          } else {
            this.form.confirm = 0;
          }
          if (this.form.allow_balance_due) {
            this.form.allow_balance_due = 1;
          } else {
            this.form.allow_balance_due = 0;
          }
          if (this.form.inventory) {
            this.form.inventory = 1;
          } else {
            this.form.inventory = 0;
          }
          this.agentIndexAction({
            type: "post",
            form_item: this.form,
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    this.agentIndexAction({
      type: "get",
    });
  },
  computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.agent.result,
    }),
  },
  watch: {
    result(val) {
      this.form = val.data;
      if (val.code == 301) {
        this.$message({
          message: "恭喜你，更新成功",
          type: "success",
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.box-card {
  padding: 18px 0;
  margin-top: 20px;
  margin-right: 10px;
}
</style>
